import styled from '@emotion/styled';

import createSizes from './utilities/sizes';
import { Screens } from '../../PageBuilder/editing/Viewport';
import News from '../oc-news';

const Sizes = createSizes();

// Styled Components
const NewsWrapper = styled.div`
  display: flex;
  justify-content: ${props => (props.alignment === 'Left' ? 'flex-start' : 'center')};
`;

const NewsContainer = styled.div`
  margin: 0;
  width: 100%;

  @media (min-width: ${Screens.Tablet}px) {
    width: ${({ width }) => `${width.Tablet}px`};
  }

  @media (min-width: ${Screens.Desktop}px) {
    width: ${({ width }) => `${width.Desktop}px`};
  }
`;

const CMSNews = ({ news, newsHeading, customCta, containerSettings = { size: 'xl', alignment: 'Left' } }) => {
  const { size, alignment } = containerSettings;
  const Width = Sizes[size || 'xl'];

  return (
    <NewsWrapper alignment={alignment}>
      <NewsContainer size={size} width={Width}>
        <News
          news={news}
          newsHeading={newsHeading}
          cta={customCta?.cta}
          ctaUrl={customCta?.ctaUrl || 'https://newsroom.owenscorning.com'}
          ctaText={customCta?.ctaText || 'More News'}
        />
      </NewsContainer>
    </NewsWrapper>
  );
};

export default CMSNews;
